module.exports = {
	"nm": "Loader Payment",
	"ddd": 0,
	"h": 500,
	"w": 500,
	"meta": {
		"g": "@lottiefiles/toolkit-js 0.33.2"
	},
	"layers": [
		{
			"ty": 4,
			"nm": "credit card",
			"sr": 1,
			"st": 0,
			"op": 240,
			"ip": 0,
			"hd": false,
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						11.207,
						21.121,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.834,
								"y": 0
							},
							"i": {
								"x": 0.579,
								"y": 1.077
							},
							"s": [
								100,
								100,
								100
							],
							"t": 0
						},
						{
							"o": {
								"x": 0.439,
								"y": 0.095
							},
							"i": {
								"x": 0.202,
								"y": 1
							},
							"s": [
								86,
								86,
								100
							],
							"t": 52.984
						},
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								100,
								100,
								100
							],
							"t": 107.797
						},
						{
							"o": {
								"x": 0.834,
								"y": 0
							},
							"i": {
								"x": 0.579,
								"y": 1.077
							},
							"s": [
								100,
								100,
								100
							],
							"t": 121.018
						},
						{
							"o": {
								"x": 0.439,
								"y": 0.095
							},
							"i": {
								"x": 0.202,
								"y": 1
							},
							"s": [
								86,
								86,
								100
							],
							"t": 174.002
						},
						{
							"s": [
								100,
								100,
								100
							],
							"t": 228.814453125
						}
					],
					"ix": 6
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						250,
						250,
						0
					],
					"ix": 2
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				}
			},
			"ef": [],
			"shapes": [
				{
					"ty": "gr",
					"bm": 0,
					"hd": false,
					"mn": "ADBE Vector Group",
					"nm": "Rectangle 2",
					"ix": 1,
					"cix": 2,
					"np": 3,
					"it": [
						{
							"ty": "rc",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Shape - Rect",
							"nm": "Rectangle Path 1",
							"d": 1,
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"s": {
								"a": 0,
								"k": [
									200,
									0.1
								],
								"ix": 2
							}
						},
						{
							"ty": "st",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Graphic - Stroke",
							"nm": "Stroke 1",
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 15,
								"ix": 5
							},
							"c": {
								"a": 0,
								"k": [
									0.1961,
									0.4235,
									0.7294
								],
								"ix": 3
							}
						},
						{
							"ty": "tr",
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"p": {
								"a": 0,
								"k": [
									11.207,
									3.017
								],
								"ix": 2
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							}
						}
					]
				},
				{
					"ty": "gr",
					"bm": 0,
					"hd": false,
					"mn": "ADBE Vector Group",
					"nm": "Rectangle 1",
					"ix": 2,
					"cix": 2,
					"np": 3,
					"it": [
						{
							"ty": "rc",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Shape - Rect",
							"nm": "Rectangle Path 1",
							"d": 1,
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 20,
								"ix": 4
							},
							"s": {
								"a": 0,
								"k": [
									200,
									126.724
								],
								"ix": 2
							}
						},
						{
							"ty": "st",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Graphic - Stroke",
							"nm": "Stroke 1",
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 15,
								"ix": 5
							},
							"c": {
								"a": 0,
								"k": [
									0.1961,
									0.4235,
									0.7294
								],
								"ix": 3
							}
						},
						{
							"ty": "tr",
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"p": {
								"a": 0,
								"k": [
									11.207,
									21.121
								],
								"ix": 2
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							}
						}
					]
				}
			],
			"ind": 1
		},
		{
			"ty": 4,
			"nm": "loader",
			"sr": 1,
			"st": 0,
			"op": 240,
			"ip": 0,
			"hd": false,
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						250,
						250,
						0
					],
					"ix": 2
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				}
			},
			"ef": [],
			"shapes": [
				{
					"ty": "gr",
					"bm": 0,
					"hd": false,
					"mn": "ADBE Vector Group",
					"nm": "Ellipse 1",
					"ix": 1,
					"cix": 2,
					"np": 3,
					"it": [
						{
							"ty": "el",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Shape - Ellipse",
							"nm": "Ellipse Path 1",
							"d": 1,
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"s": {
								"a": 0,
								"k": [
									338,
									338
								],
								"ix": 2
							}
						},
						{
							"ty": "st",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Graphic - Stroke",
							"nm": "Stroke 1",
							"lc": 2,
							"lj": 2,
							"ml": 1,
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 15,
								"ix": 5
							},
							"c": {
								"a": 0,
								"k": [
									0.1961,
									0.4235,
									0.7294
								],
								"ix": 3
							}
						},
						{
							"ty": "tr",
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							}
						}
					]
				},
				{
					"ty": "tm",
					"bm": 0,
					"hd": false,
					"mn": "ADBE Vector Filter - Trim",
					"nm": "Trim Paths 1",
					"ix": 2,
					"e": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.512,
									"y": 0
								},
								"i": {
									"x": 0.256,
									"y": 1
								},
								"s": [
									0.1
								],
								"t": 0
							},
							{
								"o": {
									"x": 0.333,
									"y": 0
								},
								"i": {
									"x": 0.833,
									"y": 1
								},
								"s": [
									100
								],
								"t": 79.551
							},
							{
								"o": {
									"x": 0.167,
									"y": 0
								},
								"i": {
									"x": 0.667,
									"y": 1
								},
								"s": [
									100
								],
								"t": 120
							},
							{
								"o": {
									"x": 0.512,
									"y": 0
								},
								"i": {
									"x": 0.256,
									"y": 1
								},
								"s": [
									0.1
								],
								"t": 121.018
							},
							{
								"o": {
									"x": 0.333,
									"y": 0
								},
								"i": {
									"x": 0.833,
									"y": 1
								},
								"s": [
									100
								],
								"t": 200.568
							},
							{
								"s": [
									100
								],
								"t": 238.982421875
							}
						],
						"ix": 2
					},
					"o": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									0
								],
								"t": 0
							},
							{
								"s": [
									360
								],
								"t": 238.982421875
							}
						],
						"ix": 3
					},
					"s": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0
								},
								"i": {
									"x": 0.667,
									"y": 1
								},
								"s": [
									0
								],
								"t": 0
							},
							{
								"o": {
									"x": 0.512,
									"y": 0
								},
								"i": {
									"x": 0.256,
									"y": 1
								},
								"s": [
									0
								],
								"t": 40.449
							},
							{
								"o": {
									"x": 0.333,
									"y": 0
								},
								"i": {
									"x": 0.833,
									"y": 1
								},
								"s": [
									99.9
								],
								"t": 120
							},
							{
								"o": {
									"x": 0.167,
									"y": 0
								},
								"i": {
									"x": 0.667,
									"y": 1
								},
								"s": [
									0
								],
								"t": 121.018
							},
							{
								"o": {
									"x": 0.512,
									"y": 0
								},
								"i": {
									"x": 0.256,
									"y": 1
								},
								"s": [
									0
								],
								"t": 161.467
							},
							{
								"s": [
									99.9
								],
								"t": 238.982421875
							}
						],
						"ix": 1
					},
					"m": 1
				}
			],
			"ind": 2
		}
	],
	"v": "5.12.1",
	"fr": 60,
	"op": 240,
	"ip": 0,
	"assets": []
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lotties/PaymentAccountFormLoader.json
// module id = 5355
// module chunks = 39